export const OVERVIEW_PANEL_RISK_MANAGEMENT_CATEGORIES_IDS = {
    RISK_CATEGORY_ID: 'risk',
};

